/**
 * should never be called in production
 */
export function assertNever(x: never, label: string): never {
  throw new Error(`Missing configuration label from type ${label} ${x}`);
}
